// src/api/taxFormsApi.js
import { getAxiosInstance } from "../utils/apiClient";
import { normalizeUsername } from "../utils/normalizeUsername";
import { getTokens } from "../utils/tokens";

const axiosInstance = getAxiosInstance();

/** ===================== Creator ===================== **/

// GET /api/tax-form/my — мої подані форми
export const myTaxFormsAPI = () =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/tax-form/my", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });

// ✅ NEW: GET /api/tax-form/my/required — що потрібно подати та поточний статус
export const myRequiredTaxFormAPI = () =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/tax-form/my/required", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data)) // { requiredType, currentStatus, currentFormId, note }
      .catch((err) => reject(err?.response?.data || err));
  });

// src/api/taxForms.ts

/** POST /api/tax-form/draft — створити чернетку (type: "W9" | "W8BEN") */
export const startTaxFormDraftAPI = ({ type }) =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        "/api/tax-form/tax-form/draft",
        { type },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data)) // { draft }
      .catch((err) => reject(err?.response?.data || err));
  });

/** PATCH /api/tax-form/:id — оновити поля чернетки */
export const updateTaxFormDraftAPI = ({ id, fields }) =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch(
        `/api/tax-form/tax-form/${id}`,
        { fields }, // { [key]: value }
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data)) // { draft }
      .catch((err) => reject(err?.response?.data || err));
  });

/** POST /api/tax-form/:id/sign — зберегти підпис
 * payload варіанти:
 *  - { method: "draw", dataUrl: "data:image/png;base64,..." }
 *  - { method: "typed", name: "John Doe" }
 */
export const saveTaxFormSignatureAPI = ({ id, payload }) =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(`/api/tax-form/tax-form/${id}/sign`, payload, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data)) // { draft }
      .catch((err) => reject(err?.response?.data || err));
  });

/** POST /api/tax-form/:id/generate — згенерувати PDF з чернетки */
export const generateTaxFormPdfAPI = ({ id }) =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        `/api/tax-form/tax-form/${id}/generate`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data)) // { message, draft, file? }
      .catch((err) => reject(err?.response?.data || err));
  });

/** POST /api/tax-form/:id/submit — відправити форму на перевірку */
export const submitTaxFormAPI = ({ id }) =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        `/api/tax-form/tax-form/${id}/submit`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data)) // { message, form, draft }
      .catch((err) => reject(err?.response?.data || err));
  });

/** GET /api/tax-form/my — список моїх форм + активна чернетка (якщо є) */
export const listMyTaxFormsAPI = () =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/tax-form/my", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data)) // { forms, activeDraft? }
      .catch((err) => reject(err?.response?.data || err));
  });

// /** (В тебе вже є) GET /api/tax-form/my/required — який тип потрібен зараз */
// export const myRequiredTaxFormAPI = () =>
//     new Promise((resolve, reject) => {
//         const tokens = getTokens();
//         axiosInstance
//             .get("/api/tax-form/my/required", {
//                 headers: {
//                     "Content-Type": "application/json",
//                     [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
//                     [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
//                     "ngrok-skip-browser-warning": "true",
//                 },
//             })
//             .then((res) => resolve(res.data)) // { requiredType, currentStatus, currentFormId, note }
//             .catch((err) => reject(err?.response?.data || err));
//     });

/** (В тебе вже є) POST /api/tax-form/upload — пряме завантаження PDF/JPG/PNG */
// export const uploadTaxFormAPI = ({ type, file }) =>
//     new Promise((resolve, reject) => {
//         const tokens = getTokens();
//         const formData = new FormData();
//         formData.append("type", type); // "W9" | "W8BEN"
//         formData.append("file", file); // PDF/JPG/PNG
//
//         axiosInstance
//             .post("/api/tax-form/upload", formData, {
//                 headers: {
//                     // не ставимо Content-Type вручну (браузер додасть boundary)
//                     [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
//                     [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
//                     "ngrok-skip-browser-warning": "true",
//                 },
//             })
//             .then((res) => resolve(res.data)) // { message, form }
//             .catch((err) => reject(err?.response?.data || err));
//     });

// POST /api/tax-form/upload — завантажити W-9 / W-8BEN (multipart/form-data)
export const uploadTaxFormAPI = ({ type, file }) =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    const formData = new FormData();
    formData.append("type", type); // "W9" | "W8BEN"
    formData.append("file", file); // PDF/JPG/PNG

    axiosInstance
      .post("/api/tax-form/upload", formData, {
        headers: {
          // НЕ задаємо Content-Type вручну — браузер поставить boundary
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });

/** ===================== Admin ===================== **/

// GET /api/tax-form/admin — список (фільтри: status, type, userId, country, from, to, page, limit)
export const adminListTaxFormsAPI = ({
  status,
  type,
  username,
  country,
  from,
  to,
  page = 1,
  limit = 20,
  sortBy = "createdAt",
  sortDir = "desc",
} = {}) =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/tax-form/admin", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { status, type, username: normalizeUsername(username), country, from, to, page, limit, sortBy, sortDir, },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });

// GET /api/tax-form/admin/:id — деталі однієї форми
export const adminGetTaxFormAPI = (id) =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get(`/api/tax-form/admin/${id}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });

// POST /api/tax-form/admin/:id/verify — верифікувати
export const adminVerifyTaxFormAPI = (id) =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        `/api/tax-form/admin/${id}/verify`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });

// POST /api/tax-form/admin/:id/reject — відхилити (з нотаткою)
export const adminRejectTaxFormAPI = (id, { note } = {}) =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        `/api/tax-form/admin/${id}/reject`,
        { note },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
